export enum Frequency {
  ANNUAL = 'Annual',
  MONTHLY = 'Monthly',
  WEEKLY = 'Weekly',
  DAILY = 'Daily',
  ONE_TIME = 'OneTime'
}
